import React, { useState } from "react";
import { useAppServices } from "hook/services";
import { useAgencyInfo } from "context/agency";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { Button } from "@mui/material";
import { useUploadImage, uploadImageToGhl } from "hook/services";
import deleteIcon from "../../../../../assets/themeIcons/delete-icon.svg";
import editIcon from "../../../../../assets/themeIcons/edit-icon.svg";
import toast from "react-hot-toast";
import ReactCropModal from "layouts/super-admin/settings/Configurator/components/ReactCropModal/ReactCropModal";

function Team({ formData, handleRefresh }) {
  const AppService = useAppServices();
  const [success, setSuccess] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const uploadImage = useUploadImage();
  const [loadingButton, setLoadingButton] = useState(false);
  const [agency] = useAgencyInfo();

  const [currentFormData, setCurrentFormData] = useState({
    image: "",
    name: "",
    designation: "",
    description: "",
  });

  // Crop modal states
  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);
  const [tempImageFile, setTempImageFile] = useState(null);
  const [imageUploading, setImageUploading] = useState(false);

  // Open crop modal when file selected
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setTempImageFile(file);
      setCurrentImage(URL.createObjectURL(file));
      setCropModalOpen(true);
    }
  };

  // After cropping, upload image
  const handleCroppedImage = async (blob) => {
    if (!blob) return;

    setImageUploading(true);
    try {
      const file = new File([blob], "cropped-team-image.jpg", {
        type: "image/jpeg",
      });
      const image_response = await uploadImageToGhl(file, agency);

      if (image_response?.data) {
        setCurrentFormData((prev) => ({
          ...prev,
          image: image_response.data,
        }));
        toast.success("Image uploaded successfully!");
      } else {
        toast.error("Failed to upload image");
      }
    } catch (err) {
      console.error("Image upload failed:", err);
      toast.error("Error uploading image");
    } finally {
      setImageUploading(false);
      setCropModalOpen(false);
      setTempImageFile(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingButton(true);

    const newTeam = {
      image: currentFormData.image,
      name: currentFormData.name,
      designation: currentFormData.designation,
      description: currentFormData.description,
    };

    let updatedTeam;
    if (isEditing) {
      updatedTeam = formData.team.map((item, index) =>
        index === editingIndex ? newTeam : item
      );
    } else {
      updatedTeam = Array.isArray(formData.team)
        ? [...formData.team, newTeam]
        : [newTeam];
    }

    const payload = {
      _id: formData.id,
      team: updatedTeam,
    };

    const { response } = await AppService.accounts.update({ payload });
    if (response) {
      handleRefresh();
      resetForm();
      setLoadingButton(false);
      toast.success("Data updated Successfully");
    } else {
      toast.error("Error updating Data");
      setLoadingButton(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCurrentFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setSuccess("");
  };

  const handleEdit = (team, index) => {
    setCurrentFormData(team);
    setIsEditing(true);
    setEditingIndex(index);
  };

  const deleteTeam = async (team) => {
    const payload = {
      _id: formData.id,
      team: formData.team.filter((item) => item !== team),
    };
    const { response } = await AppService.accounts.update({ payload });
    if (response) {
      handleRefresh();
      toast.success("Delete Successfully");
    } else {
      toast.error("Error deleting");
    }
  };

  const resetForm = () => {
    setCurrentFormData({
      image: "",
      name: "",
      designation: "",
      description: "",
    });
    setIsEditing(false);
    setEditingIndex(null);
    setCurrentImage(null)
          setTempImageFile(null);


  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          <div
            style={{
              width: "25%",
              padding: "10px 10px 0px 10px",
              border: "1px solid #ccc",
            }}
          >
            <div>
              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">Image</label>
                <input
                  type="file"
                  className="form-control-agust"
                  name="image"
                  accept="image/*"
                  onChange={handleImageUpload}
                />
                {/* {currentFormData.image && (
                  <div style={{ marginTop: "10px" }}>
                    <img
                      src={currentFormData.image}
                      alt="Team"
                      width={100}
                      height={100}
                      style={{
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "50%",
                      }}
                    />
                  </div>
                )} */}
              </SoftBox>

              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">Full Name</label>
                <input
                  className="form-control-agust"
                  onChange={handleChange}
                  value={currentFormData.name}
                  placeholder="Full Name"
                  name="name"
                />
              </SoftBox>

              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">Designation</label>
                <input
                  className="form-control-agust"
                  onChange={handleChange}
                  value={currentFormData.designation}
                  placeholder="Designation"
                  name="designation"
                />
              </SoftBox>

              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">Description</label>
                <textarea
                  className="form-control-agust"
                  onChange={handleChange}
                  value={currentFormData.description}
                  placeholder="Description"
                  name="description"
                />
              </SoftBox>
            </div>
            <div style={{ margin: "10px 0px", textAlign: "right" }}>
              <SoftButton
                disabled={loadingButton || imageUploading}
                type="submit"
                color="black"
                variant="contained"
              >
                {loadingButton
                  ? "loading..."
                  : isEditing
                    ? "Update Team"
                    : "Add Team"}
              </SoftButton>
            </div>
          </div>

          <div style={{ width: "75%", paddingLeft: "10px" }}>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
              {formData.team &&
                formData.team.map((team, index) => (
                  <div
                    key={index}
                    style={{
                      width: "25%",
                      padding: "10px",
                      textAlign: "center",
                      border: "1px solid #ccc",
                    }}
                  >
                    <img
                      src={
                        team?.image ||
                        "https://www.w3schools.com/howto/img_avatar.png"
                      }
                      className="img-fluid rounded-top"
                      alt=""
                      width={100}
                      height={100}
                      style={{
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "50%",
                      }}
                    />
                    <p>
                      <b>{team.name}</b>
                    </p>
                    <b>{team.designation}</b>
                    <div>
                      <small>{team.description}</small>
                    </div>
                    <br />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        gap: "10px",
                      }}
                    >
                      <Button
                        variant="contained"
                        color="white"
                        onClick={() => handleEdit(team, index)}
                      >
                        <img src={editIcon} width={20} alt="edit" />
                      </Button>
                      <Button
                        variant="contained"
                        color="white"
                        style={{ background: "#e44d36", color: "#fff" }}
                        onClick={() => deleteTeam(team)}
                      >
                        <img src={deleteIcon} width={20} alt="delete" />
                      </Button>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </form>

      {/* ReactCropModal */}
      <ReactCropModal
        open={cropModalOpen}
        onClose={() => setCropModalOpen(false)}
        currentImage={currentImage}
        onCropComplete={handleCroppedImage}
      // aspectRatio={1} // square crop for profile/team pics
      />
    </div>
  );
}

export default Team;
